import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import SimpleText from "components/SimpleText"
import PageHeading from "components/PageHeading"
import PageMetadata from "components/PageMetadata"
import AgendaGrid from "components/AgendaGrid"
import TrackPill from "components/TrackPill"
import theme from "theme"

const AgendaPage = ({
  data: {
    talkData: { talks },
    trackData: { tracks },
    page: { metadata, description },
  },
}) => (
  <div>
    <PageMetadata {...metadata} />

    <PageHeading>
      <div>
        <h1 css={theme.h1}>Agenda</h1>
      </div>

      <div>
        <SimpleText content={description} />

        <div css={{ display: "flex", flexWrap: "wrap", marginTop: 16 }}>
          {tracks.map(({ _id, ...trackProps }) => (
            <TrackPill
              key={_id}
              {...trackProps}
              css={{ marginRight: 8, marginBottom: 8 }}
            />
          ))}
        </div>
      </div>
    </PageHeading>

    <AgendaGrid talks={talks} />
  </div>
)

export default AgendaPage

AgendaPage.propTypes = {
  data: PropTypes.shape({
    talkData: PropTypes.shape({
      talks: AgendaGrid.propTypes.talks,
    }).isRequired,
    trackData: PropTypes.shape({
      tracks: PropTypes.arrayOf(PropTypes.shape(TrackPill.propTypes).isRequired)
        .isRequired,
    }).isRequired,
    page: PropTypes.shape({
      metadata: PropTypes.object.isRequired,
      description: PropTypes.arrayOf(PropTypes.object).isRequired,
    }).isRequired,
  }).isRequired,
}

export const query = graphql`
  query AgendaQuery($currentEventId: String!) {
    talkData: allSanityConfigTalk(
      sort: { fields: [time], order: [ASC] }

      # Only show talks associated with the current event
      filter: { event: { _id: { eq: $currentEventId } } }
    ) {
      talks: nodes {
        ...TalkCard
        toBeAnnounced
        stage
      }
    }

    trackData: allSanityConfigTrack(
      # Only show tracks associated with the current event
      filter: { event: { _id: { eq: $currentEventId } } }
    ) {
      tracks: nodes {
        _id
        ...TrackPill
      }
    }

    page: sanityConfigSettings {
      metadata: agendaMetadata {
        ...Metadata
      }

      description: _rawAgendaDescription
    }
  }
`
